import { useDispatch } from 'react-redux';
import { useState, useRef, useEffect } from 'react';
// @ts-expect-error Untyped import
import ReportErrorMessage from '../ReportErrorMessage';
import { ReportDescription } from '../ReportDescription';
// @ts-expect-error Untyped import
import { ReportingTracker } from '../../lib/usageTracker';
import { ReportsGridCardInfo } from './ReportsGridCardInfo';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
// @ts-expect-error Untyped import
import { getReports } from '../../actions/reportsActions';
// @ts-expect-error Untyped import
import { updateReport } from '../../actions/reportsActions';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { ReportLink } from '../reportsView/shared/ReportLink';
// @ts-expect-error Untyped import
import { getReportCounts } from '../../actions/reportsActions';
// @ts-expect-error Untyped import
import { getDashboards } from '../../actions/dashboardsActions';
// @ts-expect-error Untyped import
import { clearReportsFilters } from '../../actions/reportsActions';
import AsyncReportActions from '../reportsTable/AsyncReportActions';
import { SelectReportCheckbox } from '../common/SelectReportCheckbox';
import { useReportLinkProblem } from '../../utils/useReportLinkProblem';
import { ReportFavoriteButton } from '../reportsView/shared/ReportFavoriteButton';
import ReportCardV2 from 'reporting-enablement/components/ReportCard/ReportCardV2';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
// @ts-expect-error Untyped import
import { hasSufficientReportEditPermission } from 'reporting-action-components/lib/report-logic';
// @ts-expect-error Untyped import
import useReportTypeProblem from 'reporting-action-components/reportingActions/shared/problemHooks/useReportTypeProblem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReportsGridCard = ({
  report,
  onSelectReport,
  isSelected,
  selectedCards
}) => {
  const dispatch = useDispatch();
  const reportAccessProblem = useReportTypeProblem({
    report
  });
  const {
    problem,
    TooltipMessage
  } = useReportLinkProblem(report);
  const selectDisabled = !hasSufficientReportEditPermission(report);
  const [isToolbarActive, setIsToolbarActive] = useState(false);
  const cardRef = useRef(null);
  const showToolbar = () => setIsToolbarActive(true);
  useEffect(() => {
    if (!selectedCards.isEmpty()) {
      showToolbar();
    } else {
      setIsToolbarActive(false);
    }
  }, [selectedCards]);
  const hideToolbar = e => {
    // Only hide if focus/hover leaves the card and its children
    if (selectedCards.isEmpty() && cardRef.current && e.relatedTarget && e.relatedTarget instanceof Node && !cardRef.current.contains(e.relatedTarget)) {
      setIsToolbarActive(false);
    }
  };
  const toolbarVisible = isSelected || isToolbarActive;
  return /*#__PURE__*/_jsx("div", {
    ref: cardRef,
    onFocus: showToolbar,
    onBlur: hideToolbar,
    onMouseEnter: showToolbar,
    onMouseLeave: hideToolbar,
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      compact: true,
      blockSize: "500px",
      margin: "0",
      textAlign: "left",
      children: [/*#__PURE__*/_jsx(CardHeader, {
        paddingBlockStart: "300",
        paddingBlockEnd: "0",
        title: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          paddingBlock: "300",
          gap: "200",
          children: [/*#__PURE__*/_jsx(HelpIcon, {
            title: /*#__PURE__*/_jsx(ReportsGridCardInfo, {
              report: report
            }),
            size: "small",
            marginBlockStart: "100",
            tooltipProps: {
              maxInlineSize: '100%'
            }
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-200",
            children: /*#__PURE__*/_jsx(ReportLink, {
              report: report,
              problem: problem,
              TooltipMessage: TooltipMessage,
              showDescription: false
            })
          })]
        }),
        titleSize: "small",
        toolbar: toolbarVisible && /*#__PURE__*/_jsxs(Flex, {
          inlineSize: "100%",
          justifyContent: "end",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(View, {
            children: /*#__PURE__*/_jsx(ReportFavoriteButton, {
              report: report
            })
          }), /*#__PURE__*/_jsx(View, {
            children: /*#__PURE__*/_jsx(AsyncReportActions, {
              isReportLocked: !!reportAccessProblem,
              onClone: () => {
                dispatch(getDashboards());
                dispatch(clearReportsFilters());
                dispatch(getReportCounts());
              },
              onUpdate: updateReport,
              onAddToDashboard: getReports,
              report: report,
              useCompact: true,
              onFocusLeave: () => {
                setIsToolbarActive(false);
              }
            })
          }), /*#__PURE__*/_jsx(SelectReportCheckbox, {
            isSelected: isSelected,
            handleSelectedChange: e => onSelectReport(report, e.target.checked),
            isDisabled: selectDisabled
          })]
        })
      }), /*#__PURE__*/_jsxs(CardSection, {
        children: [!problem && report.get('description') && /*#__PURE__*/_jsx(View, {
          paddingBlockEnd: "400",
          children: /*#__PURE__*/_jsx(ReportDescription, {
            report: report,
            truncate: true
          })
        }), /*#__PURE__*/_jsx(ReportCardV2, {
          addOns: ['DISABLE_CARD_WRAPPER'],
          report: report,
          errorRenderer: ReportErrorMessage,
          blockSize: report.get('description') ? '325px' : '390px',
          appUsageTracker: ReportingTracker
        })]
      })]
    })
  });
};